import {createGlobalStyle} from "styled-components";

const GlobalStyles = createGlobalStyle`
  body {
    margin: 0;
    padding: 0;
    background: #f5f5f5;
    box-sizing: border-box;
    font-family: "Open Sans",serif;
  }
`

export default GlobalStyles